export const api = {
  PRE_REGISTER: 'auth/preRegister',
  REGISTER: 'auth/register',
  LOGIN: 'auth/login',
  REFRESH_TOKEN: 'auth/refreshToken',
  LOGOUT: 'auth/logout',
  SEND_CONTACT_MAIL: 'contact/sendContactMail',
  GET_SHUMA_BASIC_DATA_FILES: '/inspections/getShumaBasicDataAndFileList',
  GET_FILE: '/files/getFile',
  GET_ORDER_FILE: 'files/getOrderFile',
  GET_ORDER_FILES_LIST: 'files/getOrderFilesList',
  GET_SHARED_FILES_LIST: '/files/getSharedFilesList',
  GET_PRIVATE_FILES_LIST: '/files/getPrivateFilesList',
  GET_SHARED_FILE: '/files/getSharedFile',
  COPY_ORDER_FILE: 'files/copyFileFromOrderToShuma',
  COPY_SHARED_FILE: 'files/copyFileFromSharedToShuma',
  COPY_PRIVATE_FILE: 'files/copyFileFromShumaToShuma',
  SEND_FINAL_PDF: '/inspections/sendFinalPDF',
  FIND_CUSTOMER: '/preSteps/findCustomer',
  ADD_EDIT_CUSTOMER: '/customers/addEditCustomer',
  GET_CUSTOMER_DETAILS: '/customers/getCustomerDetails',
  GET_FILE_MONITOR_INSTALLER: '/files/getFileMonitorInstaller',
};
